/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1903788076 — ServiceComplete */

import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router-dom';

import styles from './ServiceComplete.module.css';

import { saveBlobFile } from '../../../../shared';
import { useAppStore } from '../../../../shared/hooks/useAppStore';
import { ContentBox, PrimaryButton, ScreenTitle, ScreenWrapper } from '../../../../shared/ui';
import { AnimatedIcon } from '../../../../shared/ui/AnimatedIcon/AnimatedIcon';
import tickAnimation from '../../../../shared/ui/AnimatedIcon/animations/tick.json';
import vmAnimation from '../../../../shared/ui/AnimatedIcon/animations/vm.json';
import { useGetCheck } from '../../hooks/useGetCheck';
import { useServiceStore } from '../../hooks/useServiceStore';
import { SERVICE_ROUTES } from '../../service.constants';

export const ServiceComplete = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const getCheckMutation = useGetCheck();

    const { qr: qrId } = useAppStore((s) => s.vm);
    const data = useServiceStore((s) => s.receiptData);

    const currentFiscalId = data.current_fiscal_ID;
    const isFiscalIdEmpty = currentFiscalId === '';

    const onGetReceiptError = (error: Error) => {
        console.error(
            {
                module: 'service',
                action: 'getCheck',
                fiscalId: currentFiscalId,
            },
            error,
        );
        navigate(generatePath(SERVICE_ROUTES.fail, { id: qrId }), {
            replace: true,
        });
    };

    const onGetReceipt = () => {
        getCheckMutation.mutate(currentFiscalId, {
            onSuccess: (blob) => saveBlobFile(blob, 'receipt.pdf'),
            onError: onGetReceiptError,
        });
    };

    const navigateToMainPage = (): void => {
        navigate(generatePath(SERVICE_ROUTES.main, { id: qrId }), {
            replace: true,
        });
    };

    return (
        <ScreenWrapper>
            {getCheckMutation.isPending ? (
                <ScreenWrapper>
                    <ScreenTitle>{t('Wait')} </ScreenTitle>
                    <ContentBox className={styles.vmAnimationWrapper}>
                        <AnimatedIcon animationData={vmAnimation} />
                    </ContentBox>
                </ScreenWrapper>
            ) : (
                <ScreenWrapper>
                    <ScreenTitle>{t('Thank for service')} </ScreenTitle>
                    <ContentBox className={styles.vmAnimationWrapper}>
                        <AnimatedIcon loop={false} animationData={tickAnimation} />
                    </ContentBox>
                    <PrimaryButton
                        onClick={onGetReceipt}
                        disabled={isFiscalIdEmpty}
                        className={isFiscalIdEmpty ? styles.downloadButtonDisabled : styles.downloadButton}
                    >
                        {t('Download receipt')}
                    </PrimaryButton>
                    <PrimaryButton onClick={navigateToMainPage}>
                        {t('Main page')}
                    </PrimaryButton>
                </ScreenWrapper>
            )}
        </ScreenWrapper>
    );
};
